import "./Loader.scss";

const Loader = ({ size = 20 }) => {
  return <span className="loader" style={{ width: size, height: size }}></span>;
};

export default Loader;
